// extracted by mini-css-extract-plugin
module.exports = {"container":"Button_container__GwwGZ","primary":"Button_primary__3hbdK","secondary":"Button_secondary__314hN"};